import { useCallback } from "react";

import { useAppContext } from "./useAppContext";
import { useDashboardContext } from "../contexts/dashboard-context";
import { useKeyDown } from "./useKeyboard";

interface UseCopyPasteZoneOptions {
	zone: eXpress.core.IZone | undefined;
	destinationPage: eXpress.core.IPageZone | undefined;
	isEnabled?: boolean;
}

export function useCopyPasteZone({
	zone,
	destinationPage,
	isEnabled = true,
}: UseCopyPasteZoneOptions) {
	const { clipboard } = useAppContext();
	const dashboard = useDashboardContext();

	useKeyDown(
		useCallback(
			(event: KeyboardEvent) => {
				if (!isEnabled) return;

				if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
					// Copy Zone (Ctrl+C or Cmd+C)
					if (clipboard.canCopyToClipboard(zone)) {
						clipboard.setZone(zone);
						event.preventDefault();
						event.stopPropagation();
					}
				} else if (event.key === "v" && (event.ctrlKey || event.metaKey)) {
					// Paste Zone (Ctrl+V or Cmd+V)
					const clipboardZone = clipboard.getZone();

					if (
						destinationPage &&
						dashboard.canDuplicateZone(clipboardZone, destinationPage)
					) {
						dashboard.duplicateZone(clipboardZone, destinationPage);
						event.preventDefault();
						event.stopPropagation();
					}
				}
			},
			[clipboard, dashboard, zone, destinationPage, isEnabled],
		),
	);
}
